import { AuthenticationService } from './AuthenticationService';

export interface DocumentType {
    id: string;
    name: string;
    code: string;
}

/**
 * Service voor het ophalen van metadata uit de API.
 * Gebruikt de AuthenticationService voor tokens en base URL.
 */
export class MetadataService {

    private static async get<T = any>(endpoint: string): Promise<T> {
        const token = await AuthenticationService.getToken();
        const baseUrl = await AuthenticationService.getBaseUrl();

        const response = await fetch(`${baseUrl}/api/metadata/${endpoint}`, {
            method: 'GET',
            headers: {
                'Authorization': ` ${token}`,
                'Content-Type': 'application/json',
            },
            cache: 'default',
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch metadata/${endpoint}: ${response.status} ${response.statusText}`);
        }

        return response.json();
    }

    /**
     * Haal alle beschikbare document types op voor bestandsuploads.
     * Endpoint: GET /api/metadata/Files/DocumentType
     */
    static async getDocumentTypes(): Promise<DocumentType[]> {
        return MetadataService.get<DocumentType[]>('Files/DocumentType');
    }
}
